<template>
    <div class="page_list">
        <div class="tab_box">
            <div v-for="item in tabOption" :key="item.value" 
                :class="[ 'tab_item', listType == item.value ? 'active_tab' : '' ]"
                @click="changeType(item)">
                {{ item.label }}
            </div>
        </div>
        <div class="margin-top-md padding-right-sm">
            <el-input v-model="pointKeywords" placeholder="关键字搜索" size="small" clearable prefix-icon="el-icon-search" />
        </div>
        <div class="line_list">
            <div v-for="item in computedList" :key="item.id" class="list_item" @click="checkItem(item)">
				<div class="cover">
					<el-image :src="item.cover || defaultTypeCover01" fit="cover" class="width-all height-all" alt="图片加载失败" />
					<div class="rate-tag" v-if="item.rate >= 4 || item.recommend">推荐</div>
					<div class="vr-tag" v-if="item.vrinfo && item.vrinfo !== '[]'">全景</div>
				</div>
				<div class="info">
                    <div class="name flex">
                        <span class="margin-right-md">{{ item.name }}</span>
                    </div>
                    <div class="flex" style="gap: 10px;">
                        <el-tag v-for="(tItem, tIndex) in item.tags" :key="tIndex" size="mini">{{ tItem }}</el-tag>
                    </div>
                    <div class="desc" v-if="item.remark">{{ item.remark }}</div>
                </div>
            </div>
            <div v-if="!isHaveList" class="text-white font-sm text-center" style="margin-top: 200px;">暂无记录</div>
        </div>
    </div>
</template>
<script>
    export default{
		props: {
			list: {
				type: Array,
			},
			listType: {
				type: String,
				default: 'point'
			}
		},
        data(){
            return{
                tabOption:[
					{ label: '地点', value: 'point' },
					{ label: '线路', value: 'line' },
					{ label: '项目', value: 'project' },
				],
				pointKeywords: '', // 本地搜索关键字
                listData: [],
                defaultTypeCover01: require('@/static/image/type_cover_04.png'),
            }
        },
        computed: {
			computedList(){
				if(!this.list) return []
				return this.list.filter(item => item.name.includes(this.pointKeywords))
			},
			isHaveList(){
				if(!this.list) return []
				return this.list.filter(item => item.name.includes(this.pointKeywords)).length
			},
		},
        methods: {
            changeType(item){
				if(item.value === 'project'){
					this.$message('项目暂未开放');
					return
				}
				this.$emit('change', item.value)
            },
			checkItem(item){
				this.$emit('check', item)
			},
        }
    }
</script>
<style scoped lang="scss">
    .page_list{
		padding: 10px 5px 10px 10px;
		box-sizing: border-box;
		height: 100%;
		.tab_box{
			display: flex;
			.tab_item{
				width: 70px;
				height: 30px;
				line-height: 30px;
				border-radius: 5px;
				background-color: rgba($color: #FFF, $alpha: 0.3);
				font-size: 13px;
				color: #333;
				letter-spacing: 0.3em;
				margin-right: 10px;
				transition: 300ms;
				cursor: pointer;
				text-align: center;
			}
			.active_tab{
				background-color: rgba($color: #FFF, $alpha: 0.8);
			}
		}
		.line_list{
			margin-top: 10px;
			padding-right: 5px;
			height: calc( 100% - 85px );
			overflow-y: auto;
			.list_item{
				background-color: #f1f1f1;
				border-radius: 5px;
				margin-bottom: 10px;
				cursor: pointer;
				overflow: hidden;
				padding: 10px;
				box-sizing: border-box;
				display: flex;
				gap: 10px;
				.cover{
					width: 100px;
					min-width: 100px;
					height: 100px;
					overflow: hidden;
					position: relative;
					border-radius: 5px;
					.el-image{
						transition: 200ms;
					}
					.vr-tag{
						position: absolute;
						right: 0;top: 0;
						background-color: #179BFF;
						color: #FFF;
						font-size: 14px;
						padding: 2px 10px;
						border-bottom-left-radius: 10px;
					}
					.rate-tag{
						position: absolute;
						right: 0;top: 0;
						background-color: #E74141;
						color: #FFF;
						font-size: 14px;
						padding: 2px 10px;
						border-bottom-left-radius: 10px;
					}
				}
				.info{
					font-size: 14px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.name{
						font-weight: 700;
						transition: 200ms;
						line-height: 22px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						line-clamp: 1;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
						white-space: normal !important;
						word-wrap: break-word;
					}
					.desc{
						transition: 200ms;
						font-size: 12px;
						color: #333;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						line-clamp: 3;
						-webkit-line-clamp: 3;
						-webkit-box-orient: vertical;
						white-space: normal !important;
						word-wrap: break-word;
					}
				}
			}
			.list_item:hover{
				.cover>.el-image{
					transform: scale(1.3);
				}
				.name{
					color: #199DFF;
				}
				.desc{
					color: #199DFF;
				}
			}
			.list_item:last-child{
				margin-bottom: 0
			}
			@media (max-width: 767px) {
				.list_item:hover{
					.cover>.el-image{
						transform: scale(1);
					}
				}
			}
			
		}
	}
</style>